"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicsCRMService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var constants_1 = require("../constants");
var helper_1 = require("../helper");
/**
 * The DynamicsCRM Service is made to replace a lot of the logic from the dynamicsCRMService service in full bundle.
 * While there isn't an exact 1 to 1 match this should contain a good amount of functionality
 */
var DynamicsCRMService = /** @class */ (function () {
    function DynamicsCRMService(seismicHelper) {
        this.seismicHelper = seismicHelper;
    }
    /*
     * Check whether the client type is 'DynamicsRequester' or not. Replacement of dynamicsCRMService.inDynamics
     * in full bundle
     */
    DynamicsCRMService.prototype.inDynamics = function () {
        return this.seismicHelper.getClientType() === constants_1.SeismicClientType.DYNAMICS;
    };
    DynamicsCRMService = __decorate([
        CommonService_decorator_1.CommonService('DynamicsCRMService', { replaceAngularService: 'dynamicsCRMService' }),
        __metadata("design:paramtypes", [helper_1.SeismicHelper])
    ], DynamicsCRMService);
    return DynamicsCRMService;
}());
exports.DynamicsCRMService = DynamicsCRMService;
//# sourceMappingURL=DynamicsCRM.service.js.map